module.exports = __webpack_public_path__ + "static/media/finance_mode.5642d39a.png";